import Navbar from "../../components/Navbar/Navbar";
import Cabecalho from "../../components/Cabecalho";
import { useContext, useEffect, useState } from "react";
import styles from "./styles.module.css";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import Table from "../../components/TableConstructor";
import getInstituicoes from "../../services/listarInstituicoes";
import RowInstituicoes from "../../components/TableConstructor/Row/RowInstituicoes";

type Instituicao = {
  id: number;
  nome: string; 
  cnpj: string;
  email: string;
  telefone: string;
  cep: string;
  cidade: string;
  estado: string;
  bairro: string;
  rua: string;
  numero: number;
  complemento: string;
  status: string;
  observacao:  string;
};

function Instituicoes() {
  const [listaInstituicoes, setListaInstituicoes] = useState<Instituicao[]>([]);

  const { token } = useContext(UserContext);

  const navigate = useNavigate();

  useEffect(() => {
    const listarInstituicoes = async () => {
      try {
        const instituicoes = await getInstituicoes(token);

        const listaDeInstituicoes: Instituicao[] = [];
        for (let i = 0; i < instituicoes.length; i++) {
          listaDeInstituicoes.push({
            id: instituicoes[i].id,
            nome: instituicoes[i].nome, 
            cnpj: instituicoes[i].cnpj,
            email: instituicoes[i].email,
            telefone: instituicoes[i].telefone,
            cep: instituicoes[i].cep,
            cidade: instituicoes[i].cidade,
            estado: instituicoes[i].estado,
            bairro: instituicoes[i].bairro,
            rua: instituicoes[i].rua,
            numero: instituicoes[i].numero,
            complemento: instituicoes[i].complemento,
            status: instituicoes[i].status,
            observacao:  instituicoes[i].observacao
          });
        }
        setListaInstituicoes(listaDeInstituicoes);
      } catch (error) {
        console.error("Erro ao buscar Instituições", error);
      }
    };
    listarInstituicoes();
  }, []);

  return (
    <div className={styles.page}>
      <Navbar activeIndex={0} />
      <section>
        <Cabecalho title="Listagem de Instituições" icon="group" />
        <main>
        <div className={styles.container}>
            <h3>Instituições:</h3>
            <div>
              <Table
                listTitle={[ "Nome",
                  "CNPJ",
                  "e-mail",
                  "Telefone",
                  "Endereço",
                  "Status",
                  ""]}
                styleList={[0, 1, 1, 1, 1, 1, 1]}
              >
                {listaInstituicoes.length > 0 &&
                  listaInstituicoes.map((instituicao, index) => (
                    <RowInstituicoes
                      nome={instituicao.nome}
                      cnpj={instituicao.cnpj}
                      email={instituicao.email}
                      telefone={instituicao.telefone}
                      cep={instituicao.cep}
                      cidade={instituicao.cidade}
                      estado={instituicao.estado}
                      bairro={instituicao.bairro}
                      rua={instituicao.rua}
                      numero={instituicao.numero}
                      complemento={instituicao.complemento}
                      status={instituicao.status}
                      observacao={instituicao.observacao}
                      key={index}
                    >
                      <button className={styles.viewButton} onClick={(e) => {
                        e.preventDefault();
                        navigate(`${instituicao.id}`, { state: instituicao })
                      }}>Visualizar</button>
                    </RowInstituicoes>
                  ))}
              </Table>
            </div>
          </div>
        </main>
      </section>
    </div>
  );
}

export default Instituicoes;
